<template>
  <span
    class="inline-flex items-center gap-1 min-w-0 max-w-full"
    :title="titleText"
  >
    <span class="min-w-0 truncate">{{ name }}</span>
    <user-agent-icon :user-agent="userAgent" />
    <span
      v-if="count && count > 1"
      class="shrink-0"
    >
      ({{ count }})
    </span>
  </span>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import UserAgentIcon from './user-agent-icon.vue'

const props = withDefaults(defineProps<{
  name: string
  userAgent?: string | string[] | null
  count?: number | null
  title?: string
}>(), {
  userAgent: null,
  count: null,
  title: '',
})

const titleText = computed(() => props.title || props.name)
</script>
